export type Locale = "ar" | "en";
export type Direction = "rtl" | "ltr";

/** Supported UI locales, Arabic first (the product is RTL-first). */
export const LOCALES: readonly Locale[] = ["ar", "en"];

/** Default UI language (kickoff decision #3). */
export const DEFAULT_LOCALE: Locale = "ar";

/** Locale used when a key is missing in the active catalog. */
export const FALLBACK_LOCALE: Locale = "en";

export function isLocale(value: unknown): value is Locale {
  return value === "ar" || value === "en";
}

export function directionOf(locale: Locale): Direction {
  return locale === "ar" ? "rtl" : "ltr";
}

/**
 * BCP-47 tag used for Intl formatting. Arabic UI uses Latin digits (`nu-latn`):
 * phone numbers, prices and IDs are mixed with Latin data everywhere in the product,
 * and it matches the canonical form produced by `normalizeArabic` (see ADR-0006).
 */
export function intlLocaleOf(locale: Locale): string {
  return locale === "ar" ? "ar-u-nu-latn" : "en";
}
